export default "__VITE_ASSET__Bh1BLC$b__"